__turbopack_context__.v({
  "aantal": "hours-day-visual-module__Fv9B2W__aantal",
  "button": "hours-day-visual-module__Fv9B2W__button",
  "buttonOn": "hours-day-visual-module__Fv9B2W__buttonOn",
  "caret": "hours-day-visual-module__Fv9B2W__caret",
  "count": "hours-day-visual-module__Fv9B2W__count",
  "entry": "hours-day-visual-module__Fv9B2W__entry",
  "entryFresh": "hours-day-visual-module__Fv9B2W__entryFresh",
  "entryMeta": "hours-day-visual-module__Fv9B2W__entryMeta",
  "entryName": "hours-day-visual-module__Fv9B2W__entryName",
  "entryNote": "hours-day-visual-module__Fv9B2W__entryNote",
  "fill": "hours-day-visual-module__Fv9B2W__fill",
  "fillFull": "hours-day-visual-module__Fv9B2W__fillFull",
  "footer": "hours-day-visual-module__Fv9B2W__footer",
  "footerValue": "hours-day-visual-module__Fv9B2W__footerValue",
  "form": "hours-day-visual-module__Fv9B2W__form",
  "hdEntryIn": "hours-day-visual-module__Fv9B2W__hdEntryIn",
  "hours": "hours-day-visual-module__Fv9B2W__hours",
  "hoursFresh": "hours-day-visual-module__Fv9B2W__hoursFresh",
  "lookup": "hours-day-visual-module__Fv9B2W__lookup",
  "lookupName": "hours-day-visual-module__Fv9B2W__lookupName",
  "lookupNr": "hours-day-visual-module__Fv9B2W__lookupNr",
  "lookupOpen": "hours-day-visual-module__Fv9B2W__lookupOpen",
  "lookupRow": "hours-day-visual-module__Fv9B2W__lookupRow",
  "lookupRowActive": "hours-day-visual-module__Fv9B2W__lookupRowActive",
  "note": "hours-day-visual-module__Fv9B2W__note",
  "root": "hours-day-visual-module__Fv9B2W__root",
  "track": "hours-day-visual-module__Fv9B2W__track",
});
